import { FC } from 'react';

interface SectionHeadingProps {
  children: string;
}

export const SectionHeading: FC<SectionHeadingProps> = ({ children }) => (
  <h2 className="[font-family:var(--font-arvo)] [font-size:var(--fs-h5)] font-bold text-(--neutral-black-NB900)! m-0!">
    {children}
  </h2>
);
